import { FC, ReactNode, useState } from "react"
import HandleDropdownClose from "../../hooks/handleDropdownClose"

interface DropdownProps {
  children: ReactNode
  trigger: ReactNode
  width: string
  zIndex?: number
}

const Dropdown: FC<DropdownProps> = ({ children, trigger, zIndex, width }) => {
  const [show, setShow] = useState<boolean>(false)

  const dropRef = HandleDropdownClose(() => setShow(false))

  return (
    <div
      ref={dropRef}
      className="w-fit relative"
      onClick={() => setShow((curr) => !curr)}
    >
      <div>{trigger}</div>
      {show && (
        <ul
          className={`absolute bottom-0 -right-2 translate-y-[110%] bg-white dark:bg-black border-[0.5px] border-offGrey/50 rounded-2xl overflow-hidden py-2`}
          style={{
            boxShadow: "0px 0px 14.7px 0px rgba(112, 111, 108, 0.15)",
            zIndex,
            width,
          }}
        >
          {children}
        </ul>
      )}
    </div>
  )
}

export default Dropdown
